import _ from "lodash";
import { createSelector } from "reselect";

const getGuests = (state) => _.get(state.BookingInformation, "guests", {});

const getGuestFormTemplates = (state) =>
  _.get(state.WebsiteMetadata, "metadata.guest_form_templates", []);

const propsInjector = (state, props) => props || { srvType: "MI" };

export const getGuestsFormInfoSelector = createSelector(
  [getGuests, getGuestFormTemplates, propsInjector],
  (guests, guest_form_templates, { srvType }) => {
    const adults = _.get(guests, "adults", []);
    const childs = _.get(guests, "children", []);
    const pax = adults.length + childs.length;

    const adult_lead_form_template = guest_form_templates.filter(
      (g) =>
        g.service_type === srvType && g.guest_type === "ADT" && g.lead_guest
    );
    const adult_form_template = guest_form_templates.filter(
      (g) =>
        g.service_type === srvType && g.guest_type === "ADT" && !g.lead_guest
    );
    const child_form_template = guest_form_templates.filter(
      (g) => g.service_type === srvType && g.guest_type === "CHD"
    );

    var leadAdultRequiredFields = {};
    if (adult_lead_form_template.length) {
      leadAdultRequiredFields = adult_lead_form_template[0];
    }

    var adultRequiredFields = {};
    if (adult_form_template.length) {
      adultRequiredFields = adult_form_template[0];
    }

    var childRequiredFields = {};
    if (child_form_template.length) {
      childRequiredFields = child_form_template[0];
    }

    return {
      adults,
      childs,
      pax,
      leadAdultRequiredFields,
      adultRequiredFields,
      childRequiredFields,
    };
  }
);
